/* stratos-artcrop.js
   Client note round 2 (Susanna 2026-07-24 item 1, 2026-08-03 item 6).
   Many product image FILES are square canvases with pure-white side bands
   baked in (measured: 53 to 65px per side at 480px width). On the old white
   Avenue site the baked white blended into the page; on the linen ground it
   reads as a white margin around the artwork.
   This script measures each card image's baked white margins on a small
   canvas (same-origin CDN, no taint) and trims exactly those bands with
   negative margins inside the overflow-hidden frame. No image file is
   touched; failure of any step leaves the image exactly as served. */
(function () {
  'use strict';
  var SEL = '#sxc-root .sxc-frame > img, .sxd-card-frame > img, .sxs-card-frame > img, #sxd-main';
  var MAXSIDE = 0.35;   /* never trim more than 35% from one side */
  var MINPAD = 0.04;    /* ignore bands thinner than 4%: real paper edges stay */

  function measure(probe) {
    var W = 120;
    var H = Math.max(1, Math.round(probe.naturalHeight * (W / probe.naturalWidth)));
    var c = document.createElement('canvas');
    c.width = W; c.height = H;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(probe, 0, 0, W, H);
    var d = ctx.getImageData(0, 0, W, H).data;
    function white(x, y) { var i = (y * W + x) * 4; return d[i] > 240 && d[i + 1] > 240 && d[i + 2] > 240; }
    function colFrac(x) { var n = 0, y; for (y = 0; y < H; y++) if (white(x, y)) n++; return n / H; }
    function rowFrac(y) { var n = 0, x; for (x = 0; x < W; x++) if (white(x, y)) n++; return n / W; }
    var l = 0; while (l < W * MAXSIDE && colFrac(l) > 0.92) l++;
    var r = 0; while (r < W * MAXSIDE && colFrac(W - 1 - r) > 0.92) r++;
    var t = 0; while (t < H * MAXSIDE && rowFrac(t) > 0.92) t++;
    var b = 0; while (b < H * MAXSIDE && rowFrac(H - 1 - b) > 0.92) b++;
    if ((l + r) < W * MINPAD) { l = 0; r = 0; }
    if ((t + b) < H * MINPAD) { t = 0; b = 0; }
    return { W: W, H: H, l: l, r: r, t: t, b: b, ratio: probe.naturalHeight / probe.naturalWidth };
  }

  function apply(img, m) {
    var padX = m.l + m.r;
    var padY = m.t + m.b;
    if (!padX && !padY) return;
    var visW = m.W - padX;
    if (visW < m.W * 0.3) return;
    var scale = 100 * m.W / visW;
    img.style.maxWidth = 'none';
    img.style.width = scale + '%';
    img.style.marginLeft = (-100 * m.l / visW) + '%';
    if (padY) {
      /* CSS % margins resolve against container WIDTH */
      img.style.marginTop = (-(m.t / m.H) * m.ratio * scale) + '%';
      img.style.marginBottom = (-(m.b / m.H) * m.ratio * scale) + '%';
    }
    img.dataset.sxCropped = '1';
  }

  function reset(img) {
    if (!img.dataset.sxCropped) return;
    img.dataset.sxCropped = '';
    img.style.width = '';
    img.style.maxWidth = '';
    img.style.marginLeft = '';
    img.style.marginTop = '';
    img.style.marginBottom = '';
  }

  function crop(img) {
    try {
      var src = img.currentSrc || img.src;
      if (!src) return;
      if (img.dataset.sxCropSrc === src) return;
      img.dataset.sxCropSrc = src;
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try { reset(img); apply(img, measure(probe)); } catch (e) {}
      };
      probe.src = src;
    } catch (e) {}
  }

  function prep(img) {
    if (img.dataset.sxCropBound) return;
    img.dataset.sxCropBound = '1';
    if (img.complete && img.naturalWidth) crop(img);
    img.addEventListener('load', function () { crop(img); });
  }

  function scan(root) {
    var list = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) prep(list[i]);
  }

  window.sxArtcropScan = scan;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
})();
